import { render, staticRenderFns } from "./Aplicativos.vue?vue&type=template&id=4cf8fb1e&scoped=true"
import script from "./Aplicativos.vue?vue&type=script&lang=js"
export * from "./Aplicativos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf8fb1e",
  null
  
)

export default component.exports